"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.logout = exports.fetchPerson = exports.updatePerson = exports.updateAPI = exports.initialState = exports.AUTH_PERSON_FETCH_ERROR = exports.AUTH_PERSON_FETCH_SUCCESS = exports.AUTH_PERSON_FETCH = exports.AUTH_LOGOUT = exports.AUTH_UPDATE_PERSON = exports.AUTH_UPDATE_API = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _Status = require("../../models/Status");

var _createReducer = _interopRequireDefault(require("../createReducer"));

var _ACTION_HANDLERS;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ------------------------------------
// Constants
// ------------------------------------
var AUTH_UPDATE_API = 'AUTH_UPDATE_API';
exports.AUTH_UPDATE_API = AUTH_UPDATE_API;
var AUTH_UPDATE_PERSON = 'AUTH_UPDATE_PERSON';
exports.AUTH_UPDATE_PERSON = AUTH_UPDATE_PERSON;
var AUTH_LOGOUT = 'AUTH_LOGOUT';
exports.AUTH_LOGOUT = AUTH_LOGOUT;
var AUTH_PERSON_FETCH = 'AUTH_PERSON_FETCH';
exports.AUTH_PERSON_FETCH = AUTH_PERSON_FETCH;
var AUTH_PERSON_FETCH_SUCCESS = 'AUTH_PERSON_FETCH_SUCCESS';
exports.AUTH_PERSON_FETCH_SUCCESS = AUTH_PERSON_FETCH_SUCCESS;
var AUTH_PERSON_FETCH_ERROR = 'AUTH_PERSON_FETCH_ERROR';
exports.AUTH_PERSON_FETCH_ERROR = AUTH_PERSON_FETCH_ERROR;
var initialState = {
  api: {
    path: null,
    token: null
  },
  person: null,
  status: new _Status.Status()
}; // ------------------------------------
// Action creators
// ------------------------------------

exports.initialState = initialState;

var updateAPI = function updateAPI(api) {
  return {
    type: AUTH_UPDATE_API,
    payload: api
  };
};

exports.updateAPI = updateAPI;

var updatePerson = function updatePerson() {
  var person = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: AUTH_UPDATE_PERSON,
    payload: {
      data: person
    }
  };
};

exports.updatePerson = updatePerson;

var fetchPerson = function fetchPerson() {
  return {
    type: AUTH_PERSON_FETCH,
    payload: {}
  };
};

exports.fetchPerson = fetchPerson;

var logout = function logout() {
  return {
    type: AUTH_LOGOUT,
    payload: {}
  };
}; // ------------------------------------
// Action Handlers
// ------------------------------------


exports.logout = logout;
var ACTION_HANDLERS = (_ACTION_HANDLERS = {}, _defineProperty(_ACTION_HANDLERS, AUTH_UPDATE_API, function (state, action) {
  return _objectSpread({}, state, {
    api: _objectSpread({}, state.api, {}, action.payload)
  });
}), _defineProperty(_ACTION_HANDLERS, AUTH_UPDATE_PERSON, function (state, action) {
  return _objectSpread({}, state, {
    person: action.payload.data
  });
}), _defineProperty(_ACTION_HANDLERS, AUTH_PERSON_FETCH, function (state, action) {
  return _objectSpread({}, state, {
    status: new _Status.Status(state.status.value | _Status.States.LOADING)
  });
}), _defineProperty(_ACTION_HANDLERS, AUTH_PERSON_FETCH_SUCCESS, function (state, action) {
  var person = (0, _get2["default"])(action, 'payload.data', null);
  var status = new _Status.Status(person === null ? _Status.States.UNKNOWN : _Status.States.NORMAL);
  return _objectSpread({}, state, {
    person: person,
    status: status,
    api: _objectSpread({}, state.api, {
      token: action.network.headers['set-jwt'] || state.api.token
    })
  });
}), _defineProperty(_ACTION_HANDLERS, AUTH_PERSON_FETCH_ERROR, function (state, action) {
  return _objectSpread({}, state, {
    status: new _Status.Status(_Status.States.ERROR)
  });
}), _defineProperty(_ACTION_HANDLERS, AUTH_LOGOUT, function (state, action) {
  return initialState;
}), _ACTION_HANDLERS); // ------------------------------------
// Reducer
// ------------------------------------

var _default = (0, _createReducer["default"])(initialState, ACTION_HANDLERS);

exports["default"] = _default;